import { merge } from 'lodash';
import xss, { getDefaultWhiteList } from 'xss';

const tagWhiteList = [
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'tr',
    'tt',
];

const tagStyleWhiteList = ['bgcolor'];

/**
 * 过滤 html
 */
export default function shtml(source: string) {
    source = unescape(source);

    // 针对邮件出现修改某些废弃属性的情况，导致发出的样式和编辑的样式不一致，因为被默认过滤，例如背景颜色-bgcolor，为这些属性增加白名单
    const defaultWhiteList = getDefaultWhiteList();
    if (defaultWhiteList) {
        Object.keys(defaultWhiteList).forEach((tag) => {
            if (tagWhiteList.includes(tag)) {
                defaultWhiteList[tag] = defaultWhiteList[tag]?.concat(tagStyleWhiteList);
            }
        });
    }

    return xss(source, {
        // allowCommentTag: true,
        whiteList: merge(defaultWhiteList, {
            // '!doctype': ['html'],
            html: ['lang', 'xmlns', 'dir'],
            head: [],
            meta: ['name', 'content', 'charset', 'http-equiv'],
            title: [],
            body: [],
            style: ['type'],
            includetail: [],
        }),
        stripIgnoreTag: true,
        stripIgnoreTagBody: ['script'],
        // eslint-disable-next-line consistent-return
        onIgnoreTagAttr: (tag, name, value, isWhiteAttr) => {
            if (['style', 'class'].includes(name)) {
                // 不过滤 style, class 等 attrs
                return `${name}="${value}"`;
            }
        },
        // eslint-disable-next-line consistent-return
        // onIgnoreTag: (tag, html, options) => {
        //     if (tag === '!doctype') {
        //         // 不对其属性列表进行过滤
        //         return html;
        //     }
        // },
    });
}

/**
 * 获取HTML摘要
 */
export function getSummary(source: string) {
    source = unescape(source);
    return xss(source, {
        whiteList: {},
        stripIgnoreTag: true,
        stripIgnoreTagBody: ['script', 'style'],
    });
}

/**
 * 正则匹配 html 标签内容，不包含标签
 */
// 前向零宽断言
const tagReg = /[^><]+(?=<\/?.*?>)/g;
// 后向零宽断言
// const tagReg = /(?<=<.*?>)[^><]+/g;
// const tagReg = /(?!<style.*?>)[^><]+/g;
export function matchHtmlContent(content: string) {
    // 去除 style 标签再匹配
    // content = content.replace(/<style.*?>.*?<\/style>/ig, '');
    content = content.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '');
    return content.match(tagReg);
}

// Escaping 转义正则字符串
export function escapeRegExp(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // $&表示整个被匹配的字符串
}
